import React, { useState } from 'react';
import { DropdownMenu, Search } from '@spark';
import './DatasetsFilterToolbar.css';
import UserFilterSelect from '@/shared/components/UserFilterSelect';

const getUniqueUsers = (datasets) => {
    const usersMap = new Map();
    datasets.forEach(dataset => {
        if (dataset.created_by_user) {
            const user = dataset.created_by_user;
            const userId = user.sub || user.email || (user.sub === "" ? "guest" : null);
            const userName = user.name || user.email || user.sub || 'Unknown';

            if (userId && userId !== "") {
                if (!usersMap.has(userId)) {
                    usersMap.set(userId, {
                        id: userId,
                        name: userName || userId,
                        user: user
                    });
                }
            }
        }
    });
    return Array.from(usersMap.values()).sort((a, b) => a.name.localeCompare(b.name));
};

const SORT_OPTIONS = [
    { value: 'recently_updated', label: 'Recently updated' },
    { value: 'oldest_first', label: 'Oldest first' },
    { value: 'name', label: 'Name' },
    { value: 'data_creation_type', label: 'Data Creation' },
];

const FILTER_OPTIONS = [
    { value: 'all', label: 'All Datasets' },
    { value: 'train_sets', label: 'Train sets' },
    { value: 'benchmarks', label: 'Benchmarks' },
    { value: 'manual_model_predictions', label: 'External Model Results' },
];

const DatasetsFilterToolbar = ({
    sortValue,
    onSortChange,
    filterValue,
    onFilterChange,
    searchValue,
    onSearchChange,
    userFilter,
    onUserFilterChange,
    allDatasets = []
}) => {
    const users = getUniqueUsers(allDatasets);

    const [sortOpen, setSortOpen] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);

    const selectedSort = SORT_OPTIONS.find(o => o.value === sortValue);
    const isDefaultSort = !sortValue || sortValue === 'recently_updated';

    const selectedFilter = FILTER_OPTIONS.find(o => o.value === filterValue);
    const isAllFilter = !filterValue || filterValue === 'all';

    const sortItems = SORT_OPTIONS.map(o => ({
        label: o.label,
        state: o.value === sortValue ? 'selected' : 'default',
        onClick: () => {
            onSortChange(o.value);
            setSortOpen(false);
        },
    }));

    const filterItems = FILTER_OPTIONS.map(o => ({
        label: o.label,
        state: o.value === filterValue ? 'selected' : 'default',
        onClick: () => {
            onFilterChange(o.value);
            setFilterOpen(false);
        },
    }));

    return (
        <div className="datasets-filter-toolbar">
            <div className="datasets-filter-controls fs-unmask">
                <div className="datasets-filter-dropdowns">
                    <div className="datasets-filter-dropdown-item">
                        <DropdownMenu
                            selectType="single-select"
                            showLabel={false}
                            size="medium"
                            placeholder="Recently Updated"
                            text={isDefaultSort ? undefined : selectedSort?.label}
                            panelLayout="overlay"
                            open={sortOpen}
                            onOpenChange={setSortOpen}
                            items={sortItems}
                        />
                    </div>
                    <div className="datasets-filter-dropdown-item">
                        <DropdownMenu
                            selectType="single-select"
                            showLabel={false}
                            size="medium"
                            placeholder="All Datasets"
                            text={isAllFilter ? undefined : selectedFilter?.label}
                            panelLayout="overlay"
                            open={filterOpen}
                            onOpenChange={setFilterOpen}
                            items={filterItems}
                        />
                    </div>
                    <div className="datasets-filter-dropdown-item">
                        <UserFilterSelect
                            users={users}
                            value={userFilter}
                            onChange={onUserFilterChange}
                            placeholder="All Users"
                            allValue="All Users"
                            className="user-filter-select"
                        />
                    </div>
                </div>
                <div className="datasets-filter-search">
                    <Search
                        size="medium"
                        placeholder="Search"
                        value={searchValue}
                        onChange={(e) => onSearchChange(e.target.value)}
                        showClearButton={!!searchValue}
                        onClear={() => onSearchChange('')}
                    />
                </div>
            </div>
        </div>
    );
};

export default DatasetsFilterToolbar;
